import React, {
	memo,
	useCallback,
	useState
} from 'react';
import PropTypes from 'prop-types';
// import { useHistory } from 'react-router-dom';
import {
	Dropdown,
	Popup
} from 'semantic-ui-react';

import {

	/* getActivityRoute, */
	setActivityStatus,
	snoozeActivity
} from '../../../api/nora/activities';

import {
	useDashboardAction,
	useDashboardState
} from '../../../contexts/DashboardContext';
import { useUIAction } from '../../../contexts/UIContext';

import Alert from '../../Alert';
import Active from './icons/Active';
import Complete from './icons/Complete';
import UnSnoozed from './icons/UnSnoozed';
import Snoozed from './icons/Snoozed';
import UnBookmarked from './icons/UnBookmarked';
import Bookmarked from './icons/Bookmarked';
import Unarchived from './icons/Unarchived';
import Archived from './icons/Archived';

import styles from './dashboard.module.css';

const ActivityLogActions = ( {
	includeComplete,
	includeZZZ,
	refresh,
	row
} ) => {
	const { snoozeDurations } = useDashboardState();

	const {
		removeActivity,
		setIsInSync,
		updateActivity
	} = useDashboardAction();
	const { setApiErrorAlert } = useUIAction();

	const [ completeOpen, setCompleteOpen ] = useState( false );
	const [ bookmarkOpen, setBookmarkOpen ] = useState( false );
	const [ archiveOpen, setArchiveOpen ] = useState( false );
	const [ snoozeOpen, setSnoozeOpen ] = useState( false );
	const [ deleteConfirm, setDeleteConfirm ] = useState( false );

	// const history = useHistory();

	// const handleView = useCallback( async () => {
	// 	// loader //
	// 	const { route, navigationState } = await getActivityRoute( row.id );

	// history.push( {
	// 		pathname: route,
	// 		state: {
	// 			...navigationState,
	// 			text: '\u2190\u00A0\u00A0Back to Dashboard',
	// 			to: '/dashboard'
	// 		}
	// 	} );
	// }, [ history, row.id ] );

	const handleComplete = useCallback( async () => {
		try {
			if ( row.activityStatus.id !== 77 ) { // not completed
				await setActivityStatus( row.id, 77 );

				if ( includeComplete ) {
					updateActivity( {
						...row,
						activityStatus: { id: 77 }
					} );
				} else {
					removeActivity( row.id );
				}
			} else {
				await setActivityStatus( row.id, 76 );

				updateActivity( {
					...row,
					activityStatus: { id: 76 }
				} );
			}

			setIsInSync( false );
		} catch ( error ) {
			setApiErrorAlert( error );
		}
	}, [
		includeComplete,
		removeActivity,
		row,
		setApiErrorAlert,
		setIsInSync,
		updateActivity
	] );

	const handleBookmark = useCallback( async () => {
		try {
			if ( row.activityStatus.id === 76 ) {
				await setActivityStatus( row.id, 78 );
				updateActivity( {
					...row,
					activityStatus: { id: 78 }
				} );
			} else if ( row.activityStatus.id === 78 ) { // bookmarked
				await setActivityStatus( row.id, 76 );
				updateActivity( {
					...row,
					activityStatus: { id: 76 }
				} );
			}

			// setIsInSync( false );
		} catch ( error ) {
			setApiErrorAlert( error );
		}
	}, [
		row,
		setApiErrorAlert,
		updateActivity
	] );

	const handleArchive = useCallback( () => {
		setDeleteConfirm( true );
	}, [] );

	const handleSnooze = useCallback( async ( e, { value } ) => {
		try {
			await snoozeActivity( row.id, value );

			if ( includeZZZ ) {
				updateActivity( {
					...row,
					snooze: { id: value }
				} );
			} else {
				removeActivity( row.id );
			}

			setIsInSync( false );
		} catch ( error ) {
			setApiErrorAlert( error );
		}
	}, [
		includeZZZ,
		removeActivity,
		row,
		setApiErrorAlert,
		setIsInSync,
		updateActivity
	] );

	const handleUnsnooze = useCallback( async () => {
		try {
			await snoozeActivity( row.id, 81 );
			updateActivity( {
				...row,
				snooze: { id: 81 }
			} );

			setIsInSync( false );
		} catch ( error ) {
			setApiErrorAlert( error );
		}
	}, [
		row,
		setApiErrorAlert,
		setIsInSync,
		updateActivity
	] );

	const toggleCompleteOpen = useCallback( () => {
		row.activityStatus.id === 77
			? null
			: setCompleteOpen( prev => !prev );
	}, [ row.activityStatus.id ] );

	const toggleBookmarkOpen = useCallback( () => {
		row.activityStatus.id === 77
			? null
			: setBookmarkOpen( prev => !prev );
	}, [ row.activityStatus.id ] );

	const toggleArchiveOpen = useCallback( () => {
		row.activityStatus.id === 77
			? null
			: setArchiveOpen( prev => !prev );
	}, [ row.activityStatus.id ] );

	const toggleSnoozeOpen = useCallback( () => {
		row.activityStatus.id === 77
			? null
			: setSnoozeOpen( prev => !prev );
	}, [ row.activityStatus.id ] );

	const handleDelete = useCallback( async () => {
		try {
			await setActivityStatus( row.id, 79 );
			await refresh();
		} catch ( error ) {
			setApiErrorAlert( error );
		}
	}, [
		refresh,
		row,
		setApiErrorAlert
	] );

	const deleteConfirmCloseModal = useCallback( () => setDeleteConfirm( false ), [] );

	return (
		<div
			className={ styles.actions }
			onClick={ e => {
				e.stopPropagation();
			}}
		>
			<Popup
				content={ row.activityStatus.id === 77 ? 'Mark Incomplete' : 'Mark Complete' }
				position="top center"
				trigger={ row.activityStatus.id === 77 // completed
					? <Complete
						className={ styles.complete }
						onClick={ handleComplete }
						fill="#339966"
						height="1.5em"
						width="1.5em"
						style={ {
							margin: '0 0.5rem',
							cursor: 'pointer'
						} }
					/>
					: <Active
						onClick={ handleComplete }
						onMouseOver={ toggleCompleteOpen }
						onMouseOut={ toggleCompleteOpen }
						fill={ completeOpen
							? '#000'
							: '#C8C4C4'
						}
						height="1.5em"
						width="1.5em"
						style={ {
							margin: '0 0.5rem',
							cursor: 'pointer'
						} }
					/>
				}
			/>
			<Popup
				content={ row.activityStatus.id === 78 ? 'Remove Bookmark' : 'Bookmark' }
				position="top center"
				trigger={ row.activityStatus.id === 78 // bookmarked
					? <Bookmarked
						onClick={ handleBookmark }
						fill="2E0F6B"
						height="1.5em"
						width="1.5em"
						style={ {
							margin: '0 0.5rem',
							cursor: 'pointer'
						} }
					/>
					: <UnBookmarked
						onClick={ row.activityStatus.id !== 76
							? null
							: handleBookmark
						}
						onMouseOver={ toggleBookmarkOpen }
						onMouseOut={ toggleBookmarkOpen }
						fill={
							row.activityStatus.id !== 76
								? '#C8C4C480'
								: bookmarkOpen
									? '#000'
									: '#C8C4C4'
						}
						height="1.5em"
						width="1.5em"
						style={ {
							margin: '0 0.5rem',
							cursor: 'pointer'
						} }
					/>
				}
			/>
			<Popup
				content="Archive"
				disabled={ row.activityStatus.id === 77 }
				position="top center"
				trigger={ row.activityStatus.id === 79
					? <Archived
						onClick={ handleArchive }
						fill="#FF9966"
						height="1.5em"
						width="1.5em"
						style={ { margin: '0 0.5rem' } }
					/>
					: <Unarchived
						onClick={ row.activityStatus.id === 77
							? null
							: handleArchive
						}
						onMouseOver={ toggleArchiveOpen }
						onMouseOut={ toggleArchiveOpen }
						fill={
							row.activityStatus.id === 77
								? '#C8C4C480'
								: archiveOpen
									? '#000'
									: '#C8C4C4'
						}
						height="1.5em"
						width="1.5em"
						style={ {
							margin: '0 0.5rem',
							cursor: 'pointer'
						} }
					/>
				}
			/>
			{ row.snooze.id === 0 || row.snooze.id === 81 // unsnoozed
				? <Dropdown
					onChange={ row.activityStatus.id === 77
						? null
						: handleSnooze
					}
					options={ snoozeDurations }
					icon={ false }
					trigger={
						<Popup
							content="Snooze"
							disabled={ row.activityStatus.id === 77 }
							trigger={
								<UnSnoozed
									onMouseOver={ toggleSnoozeOpen }
									onMouseOut={ toggleSnoozeOpen }
									fill={
										row.activityStatus.id === 77
											? '#C8C4C480'
											: snoozeOpen
												? '#000'
												: '#C8C4C4'
									}
									height="1.5em"
									width="1.5em"
									style={ {
										margin: '0 0.5rem',
										cursor: 'pointer'
									} }
								/>
							}
						/>
					}
				/>
				: <Popup
					content=" Turn Off Snooze"
					disabled={ row.activityStatus.id === 77 }
					position="top center"
					trigger={
						<Snoozed
							fill="#3333FF"
							height="1.5em"
							width="1.5em"
							onClick={ row.activityStatus.id === 77
								? null
								: handleUnsnooze
							}
							style={ {
								margin: '0 0.5rem',
								cursor: 'pointer'
							} }
						/>
					}
				/>
			}
			<Alert
				action={ handleDelete }
				name="activity-archive-confirm-alert"
				message="Are you sure you would like to archive this activity?"
				open={ deleteConfirm }
				closeModal={ deleteConfirmCloseModal }
				type="delete"
			/>
		</div>
	);
};

ActivityLogActions.propTypes = {
	includeComplete: PropTypes.bool,
	includeZZZ: PropTypes.bool,
	refresh: PropTypes.func.isRequired,
	row: PropTypes.object
};

export default memo( ActivityLogActions );
